// extracted by mini-css-extract-plugin
export default {"tagCloud":"TagsForm_tagCloud__SCApQ","suggestionBox":"TagsForm_suggestionBox__Vry5g","suggestionError":"TagsForm_suggestionError__7zsCU"};